export default function getOptions(objects, valueKey = "id") {
  if (!objects || !objects.length) return [];
  return objects.map((object) => ({
    key: object.id,
    value: object[valueKey],
    text: object.name,
    description: object.description,
  }));
}
